import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyCkV1-FpqZIfbJaXeL9EKe71f0b2KyI0Ao",
  authDomain: "arctec-store.firebaseapp.com",
  databaseURL: "https://arctec-store.firebaseio.com",
  projectId: "arctec-store",
  storageBucket: "arctec-store.appspot.com",
  messagingSenderId: "354075217101",
}

firebase.initializeApp(config)

const auth = firebase.auth()
const db = firebase.firestore()

export { firebase, auth, db }
